import React, { Component } from 'react';
import { Media, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Visible } from 'javascripts/portfolio/components/visible';

class Paper extends Component {
  renderPaperThumbnail() {
    const thumbnailUrl = this.props.thumbnailUrl;
    if (thumbnailUrl)
      return <img className="work-thumbnail" src={thumbnailUrl} alt="" />;

    return (
      <div className="work-thumbnail">
        <hr />
        <hr />
        <hr />
        <hr />
        <hr />
        <hr />
        <hr />
      </div>
    );
  }

  renderPaperOverview() {
    const { title, authors } = this.props;

    function commaizeAuthors(authors) {
      return authors.map((name, i) => (
        <span key={i}>
          {i > 0 && ', '}
          {name}
        </span>
      ));
    }

    return (
      <Media.Body>
        <Media.Heading>{this.renderWorkTitle(title)}</Media.Heading>
        <p className="authors">
          <span>By {commaizeAuthors(authors)}</span>
        </p>

        <Visible modes={(m) => m > 0}>
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="paperDownloadTooltip">
                {' '}
                You are in preview mode. Once you register your website,
                clicking 'Download' will download the paper.{' '}
              </Tooltip>
            }
          >
            <Button className="download-button">Download</Button>
          </OverlayTrigger>
        </Visible>

        <Visible modes={0}>{this.renderDownloadButton()}</Visible>
      </Media.Body>
    );
  }

  renderDownloadButton() {
    if (!this.props.url) return null;

    return (
      <Button
        className="download-button"
        target="_blank"
        download
        href={this.props.url}
      >
        Download
      </Button>
    );
  }

  renderWorkTitle(title) {
    const url = this.props.url || this.props.externalUrl;
    if (url)
      return (
        <a href={url} target="_blank">
          {title}
        </a>
      );

    return <p>{title}</p>;
  }

  render() {
    return (
      <Media className="work-item">
        <Media.Left className="hidden-sm hidden-xs" align="top">
          <div style={{ marginRight: '16px' }}>
            {this.renderPaperThumbnail()}
          </div>
        </Media.Left>

        {this.renderPaperOverview()}
      </Media>
    );
  }
}

export default Paper;
